<template>
<div class="excel-file-van">
    <div class="excel-header">
        <div class="excel-title">推广服务验收单</div>
        <div class="excel-control" v-if="showPrint">
            <el-button type="borderGreen" size="small" @click="openPrintCombine">打印</el-button>
        </div>
    </div>
    <table class="excel-main" >
        <thead>
            <tr>
                <th colspan="2" style="">推广服务验收单</th>
            </tr>
        </thead>
        <tbody>
            <tr class="item">
                <td class="item-label">服务方</td>
                <td class="item-content">{{data.serviceTenantName}}</td>
            </tr>
            <tr class="item">
                <td class="item-label">验收方</td>
                <td class="item-content">{{ data.tenantName }}</td>
            </tr>
            <tr class="item">
                <td class="item-label">服务时间</td>
                <td class="item-content">{{data.accountMonthStartDate}}至{{data.accountMonthEndDate}}（第{{data.billCycleList && data.billCycleList.join()}}）</td>
            </tr>
            <tr class="item">
                <td class="item-label">服务金额</td>
                <td class="item-content">
                    大写：<span class="underline">{{data.currentPayAmount | smallToBig}}</span>，
                    小写：<span class="underline">{{ data.currentPayAmount | numDigit | numFmt }}</span>
                </td>
            </tr>
            <tr class="item">
                <td class="item-label">服务交付类型和数量</td>
                <td class="item-content">
                    <p v-for="item,index in data.detailList" :key="item.guid">
                        {{index+1 | formatterIndex}}、{{item.taskContentName}} {{item.taskTotal}} {{ item.taskTotalUnit }}
                    </p>
                </td>
            </tr>
            <tr class="item">
                <td class="item-label">服务验收结论</td>
                <td class="item-content stage">
                    <div class="stage-wrapper">
                        <div class="stage-name">服务方意见（盖章）：</div>
                        <div class="stage-info">根据验收方服务要求，已完成推广服务事项具体内容实施，并提供相应服务报告，确认该服务完成，顺利交付。</div>
                        <div class="stage-date">
                            <span>{{ year }}</span>年
                            <span>{{ month }}</span>月
                            <span>{{ day }}</span>日
                        </div>
                    </div>
                    <div class="stage-wrapper">
                        <div class="stage-name">验收方意见（盖章）：</div>
                        <div class="stage-info">验收方已收到服务方提供的服务报告，符合我方服务要求，确认该服务完成，顺利验收。</div>
                        <div class="stage-date">
                            <span>{{ year }}</span>年
                            <span>{{ month }}</span>月
                            <span>{{ day }}</span>日
                        </div>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
    
    <!-- 引用 printCombine 组件 -->
    <printCombine 
        v-if="showPrintCombine"
        :showPrintDialog.sync="showPrintCombine"
        :printData="data"
        :showReceipt="true"
        :showPaymentNotice="false"
        :showPromotionPlan="false"
        @closePrint="showPrintCombine = false"
    />
</div>
</template>

<script>
import useDate from '@/uilt/recentDate'
import printCombine from './printCombine'
export default {
    components: {
        printCombine
    },
    props: {
        data: {
            type: Object,
            default: () => ({
                detailList: [],
                billCycleList: []
            })
        },
        tableData: {
            type: Array,
            default: () => ([])
        },
        showPrint: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            nowYear: useDate.getNowYear(),
            showPrintCombine: false,
            year: null,
            month: null,
            day: null
        }
    },
    created() {
        // 获取验收单日期
        if (this.data.accountMonthEndDate) {
            const [year, month, day] = this.data.accountMonthEndDate.split("-").map(item => parseInt(item));
            this.year = year;
            this.month = month;
            this.day = day;
        }
    },
    filters: {
        formatterIndex (value) {
            switch (value) {
                case 1:
                    return '一'
                case 2:
                    return '二'
                case 3:
                    return '三'
                case 4:
                    return '四'
                case 5:
                    return '五'
                case 6:
                    return '六'
                case 7:
                    return '七'
                case 8:
                    return '八'
                case 9:
                    return '九'
                case 10:
                    return '十'
                case 11:
                    return '十一'
                case 12:
                    return '十二'
                case 13:
                    return '十三'
                case 14:
                    return '十四'
                case 15:
                    return '十五'
                case 16:
                    return '十六'
                case 17:
                    return '十七'
                case 18:
                    return '十八'
                case 19:
                    return '十九'
                case 20:
                    return '二十'
                default: 
                    return value
            }
        },
        unit (value) {
            if (!value) return
            return value.split('/')[1]
        }
    },
    methods: {
        openPrintCombine() {
            this.showPrintCombine = true
        }
    }
}
</script>

<style lang="less">
.excel-file-van {
    width: 700px;
    .excel-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
    }
    .excel-title {
        font-size: 16px;
        color: #212121;
    }
    .excel-main {
        text-align: left;
        border: 1px solid #d9d9d9;
        border-collapse: collapse;
        thead {
            th {
                padding: 10px 20px 10px 8px;
                font-size: 20px;
                font-weight: bold;
                text-align: center;
            }
        }
        td {
            border: 1px solid #d9d9d9;
            padding: 10px 20px 10px 8px;
            font-size: 12px;
        }
        .item-label {
            width: 140px;
            text-align: center;
        }
        .item-content {
            padding: 10px 20px 10px 8px;
            width: calc(100% - 140px);
            .underline {
                text-decoration: underline;
            }
        }
        .stage-wrapper {
            margin-bottom: 20px;
            .stage-name {
                margin-top: 10px;
            }
            .stage-info {
                margin: 20px 0;
                text-indent: 2em;
            }
            .stage-date {
                text-align: right;
                > span {
                    margin: 0 10px;
                }
            }
            &:last-child {
                margin-bottom: 0;
            }
        }
    }
    .excel-control {
        margin-top: 10px;
    }
}
</style>